import posthog, { PostHog } from 'posthog-js'
import { parseEnv } from '@/store/modules/App/tracking/parseEnv'

export const initPostHog = (): PostHog => {
  const token = parseEnv(import.meta.env.VITE_POSTHOG_TOKEN)
  const apiHost = parseEnv(import.meta.env.VITE_POSTHOG_API_HOST)
  if (!token || !apiHost) {
    return posthog
  }
  posthog.init(token, {
    api_host: apiHost,
    person_profiles: 'identified_only',
    capture_pageview: false,
    autocapture: true,
  })
  // This is a global variable, which we can't change. But at least we can restrict the places where it is imported
  return posthog
}
